import { render, staticRenderFns } from "./percentage-circle-icon.vue?vue&type=template&id=58e6781c&scoped=true"
var script = {}
import style0 from "./percentage-circle-icon.vue?vue&type=style&index=0&id=58e6781c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6781c",
  null
  
)

export default component.exports